var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotifDelete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 112,
    viewBox: "0 0 127 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.917 61.5457C114.917 89.186 92.5097 111.593 64.8695 111.593C37.2292 111.593 14.8223 89.186 14.8223 61.5457C14.8223 33.9055 37.2292 11.498 64.8695 11.498C92.5097 11.498 114.917 33.9055 114.917 61.5457Z",
    stroke: "#C4C3C3",
    strokeWidth: 0.672854,
    strokeDasharray: "3.38 3.38"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.032 61.5458C102.032 82.0716 85.3922 98.7114 64.8664 98.7114C44.34 98.7114 27.7012 82.0716 27.7012 61.5458C27.7012 41.0199 44.34 24.3801 64.8664 24.3801C85.3922 24.3801 102.032 41.0199 102.032 61.5458Z",
    stroke: "#C4C3C3",
    strokeWidth: 0.672854,
    strokeDasharray: "3.39 3.39"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.36475 68.2843L4.43555 68.2559",
    stroke: "#D2D8DF",
    strokeWidth: 0.672854,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.69668 66.5217L4.03027 67.1443",
    stroke: "#D2D8DF",
    strokeWidth: 0.672854,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.95832 65.7173L2.94434 66.6258",
    stroke: "#D2D8DF",
    strokeWidth: 0.672854,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.16406 66.3413L1.81118 67.0039",
    stroke: "#D2D8DF",
    strokeWidth: 0.672854,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0.374023 68.0283L1.30274 68.0568",
    stroke: "#D2D8DF",
    strokeWidth: 0.672854,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1.04785 69.7905L1.71474 69.168",
    stroke: "#D2D8DF",
    strokeWidth: 0.672854,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M2.77539 70.5945L2.78937 69.686",
    stroke: "#D2D8DF",
    strokeWidth: 0.672854,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M4.57192 69.9707L3.9248 69.3081",
    stroke: "#D2D8DF",
    strokeWidth: 0.672854,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M126.546 55.3318L126.138 55.774",
    stroke: "#D2D8DF",
    strokeWidth: 0.672854,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M124.621 55.7163L124.929 56.0003",
    stroke: "#D2D8DF",
    strokeWidth: 0.672854,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M124.311 57.6763L124.719 57.2341",
    stroke: "#D2D8DF",
    strokeWidth: 0.672854,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M126.23 57.2916L125.922 57.0076",
    stroke: "#D2D8DF",
    strokeWidth: 0.672854,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1374 3.36197L88.1494 3.33545",
    stroke: "#D2D8DF",
    strokeWidth: 0.672854,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5794 0.977051L86.5645 1.82139",
    stroke: "#D2D8DF",
    strokeWidth: 0.672854,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8252 3.12476L84.8132 3.15079",
    stroke: "#D2D8DF",
    strokeWidth: 0.672854,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M86.3848 5.51059L86.3997 4.66626",
    stroke: "#D2D8DF",
    strokeWidth: 0.672854,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9645 94.5273C15.2537 94.74 14.0699 95.7844 13.6649 97.0227C13.5969 95.8722 12.8663 94.426 12.0625 94.2177C13.0433 93.871 14.1056 92.5966 14.3882 91.5227C14.337 92.6482 15.3588 94.2823 15.9645 94.5273Z",
    fill: "#D8D8D8"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.6141 7.8851C32.0658 7.98202 31.0942 8.6571 30.6853 9.54435C30.734 8.68169 30.3149 7.54129 29.7344 7.31658C30.4948 7.14299 31.3965 6.28563 31.6998 5.51025C31.5643 6.34446 32.184 7.65026 32.6141 7.8851Z",
    fill: "#D8D8D8"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.28 14.149C104.548 14.1331 103.967 13.527 103.984 12.795C104 12.063 104.606 11.4825 105.337 11.4984C106.07 11.5143 106.65 12.1204 106.634 12.8524C106.618 13.5844 106.012 14.1649 105.28 14.149Z",
    fill: "#D1D9E0"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.286 101.019C104.649 101.006 104.144 100.478 104.157 99.8408C104.171 99.2033 104.699 98.6979 105.336 98.7114C105.974 98.7254 106.479 99.253 106.465 99.8904C106.451 100.527 105.924 101.033 105.286 101.019Z",
    fill: "#D8D8D8"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.44791 31.7434C9.05347 31.7347 8.74052 31.4082 8.7492 31.0133C8.7574 30.6189 9.08433 30.3064 9.47877 30.3146C9.87321 30.3233 10.1862 30.6497 10.178 31.0442C10.1693 31.4391 9.84235 31.7521 9.44791 31.7434Z",
    stroke: "#D2D8DF",
    strokeWidth: 0.672854,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4844 69.686V53.2732L58.7153 54.5042L59.9463 53.2732L61.1772 54.5042L62.4082 53.2732L63.6392 54.5042L64.8701 53.2732L66.1011 54.5042L67.332 53.2732L68.563 54.5042L69.7939 53.2732L71.0249 54.5042L72.2559 53.2732V69.686L71.0249 68.455L69.7939 69.686L68.563 68.455L67.332 69.686L66.1011 68.455L64.8701 69.686L63.6392 68.455L62.4082 69.686L61.1772 68.455L59.9463 69.686L58.7153 68.455L57.4844 69.686ZM59.9463 65.5828H69.7939V63.9415H59.9463V65.5828ZM59.9463 62.3002H69.7939V60.6589H59.9463V62.3002ZM59.9463 59.0177H69.7939V57.3764H59.9463V59.0177Z",
    fill: "#333333"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7523 63.1985C75.8965 63.1985 76.0347 63.2558 76.1367 63.3577C76.2386 63.4597 76.2959 63.5979 76.2959 63.7421C76.2959 63.8863 76.2386 64.0246 76.1367 64.1265C76.0347 64.2285 75.8965 64.2857 75.7523 64.2857H75.2087L75.207 64.3243L74.6998 71.43C74.6803 71.7043 74.5576 71.961 74.3563 72.1484C74.1551 72.3358 73.8903 72.44 73.6153 72.44H69.1908C68.9158 72.44 68.651 72.3358 68.4498 72.1484C68.2485 71.961 68.1258 71.7043 68.1063 71.43L67.5991 64.3249C67.5982 64.3118 67.5979 64.2988 67.598 64.2857H67.0544C66.9102 64.2857 66.7719 64.2285 66.67 64.1265C66.568 64.0246 66.5107 63.8863 66.5107 63.7421C66.5107 63.5979 66.568 63.4597 66.67 63.3577C66.7719 63.2558 66.9102 63.1985 67.0544 63.1985H75.7523ZM72.4906 61.5676C72.6347 61.5676 72.773 61.6249 72.875 61.7268C72.9769 61.8288 73.0342 61.9671 73.0342 62.1112C73.0342 62.2554 72.9769 62.3937 72.875 62.4956C72.773 62.5976 72.6347 62.6549 72.4906 62.6549H70.3161C70.1719 62.6549 70.0336 62.5976 69.9317 62.4956C69.8297 62.3937 69.7725 62.2554 69.7725 62.1112C69.7725 61.9671 69.8297 61.8288 69.9317 61.7268C70.0336 61.6249 70.1719 61.5676 70.3161 61.5676H72.4906Z",
    fill: "#FF0000"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifDelete);
export default __webpack_public_path__ + "static/media/notif_delete.c3c412e98375f11f4e56855b36ccdae1.svg";
export { ForwardRef as ReactComponent };